export function output<T>() {
  return (...args: T extends void ? [] : [{ $event: T }]) => args[0];
}
